module.exports = __webpack_public_path__ + "static/img/export-icon.ef8fc72c.svg";